export const protectedPaths = [
  "/",
  "/load-rates",
  "/market-potential",
  "/profile",
  "/company-analytics",
  "/trends",
  "/loadboard",
  "/widget",
  "/load-finder",
  "/batch",
  "/broker-analytics",
];

export const widgetPath = protectedPaths[7];
export const loadFinderPath = protectedPaths[8];
export const batchPath = protectedPaths[9];
export const brokerAnalyticsPath = protectedPaths[10];

// Public, slug-based carrier truck list page (e.g. /trucklist/aaa-freight-inc)
export const trucklistPath = "/trucklist/:slug";
